"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranularityToJSON = exports.GranularityFromJSONTyped = exports.GranularityFromJSON = exports.Granularity = void 0;
/**
 * What granularity of diagnostic data is present.
 * @export
 */
exports.Granularity = {
    Daily: 'DAILY',
    Hourly: 'HOURLY'
};
function GranularityFromJSON(json) {
    return GranularityFromJSONTyped(json, false);
}
exports.GranularityFromJSON = GranularityFromJSON;
function GranularityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GranularityFromJSONTyped = GranularityFromJSONTyped;
function GranularityToJSON(value) {
    return value;
}
exports.GranularityToJSON = GranularityToJSON;
